import { CompaniesApi } from '../../generated/new';

const companiesApi = new CompaniesApi();

export default companiesApi;
